module.exports = __webpack_public_path__ + "img/4.c946945b.webp";